export default __webpack_public_path__ + "static/media/payment_insufficient.0931ddc1.svg";